export default __webpack_public_path__ + "static/media/Admin.a74ed7d0.png";